import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from '@react-oauth/google';
import store from "./redux/Store";
// Imported after App so it evaluates last and wins the cascade over the
// older page stylesheets. See the file header for what it resolves.
import "./css/brand-system.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="594149698240-22cetvku9jerg34vgav5k0p8abbll1nj.apps.googleusercontent.com">
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
  </GoogleOAuthProvider>
);
